import { SignIn, SignUp } from "@clerk/react";
import { useSEO } from "@/hooks/use-seo";
import { clerkBasePath } from "@/components/ClerkAuthProvider";
import { Layout } from "@/components/Layout";

function AuthPageFrame({ children }: { children: React.ReactNode }) {
  return (
    <Layout>
      <div className="flex min-h-[60vh] items-center justify-center px-4 py-12">
        {children}
      </div>
    </Layout>
  );
}

export function SignInPage() {
  useSEO({
    title: "Sign In | The Lifecycle Canvas",
    description: "Sign in to access your approved private canvas.",
    noIndex: true,
  });

  return (
    <AuthPageFrame>
      <SignIn
        routing="path"
        path={`${clerkBasePath}/sign-in`}
        signUpUrl={`${clerkBasePath}/sign-up`}
        forceRedirectUrl={`${clerkBasePath}/app`}
      />
    </AuthPageFrame>
  );
}

export function AdminSignInPage() {
  useSEO({
    title: "Administrator Sign In | The Lifecycle Canvas",
    description: "Restricted sign-in for Lifecycle Canvas administrators.",
    noIndex: true,
  });

  return (
    <AuthPageFrame>
      <div className="flex flex-col items-center gap-3">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-teal-300">
          Restricted administrator access
        </p>
        <SignIn
          routing="path"
          path={`${clerkBasePath}/admin/sign-in`}
          signUpUrl={`${clerkBasePath}/sign-up`}
          forceRedirectUrl={`${clerkBasePath}/admin`}
        />
      </div>
    </AuthPageFrame>
  );
}

export function SignUpPage() {
  useSEO({
    title: "Create an Account | The Lifecycle Canvas",
    description: "Create an account to access your approved Lifecycle Canvas.",
    noIndex: true,
  });

  return (
    <AuthPageFrame>
      <SignUp
        routing="path"
        path={`${clerkBasePath}/sign-up`}
        signInUrl={`${clerkBasePath}/sign-in`}
        forceRedirectUrl={`${clerkBasePath}/app`}
      />
    </AuthPageFrame>
  );
}
